
export default {
  code: "nb",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Forrige",
    next: "Neste",
    today: "I dag",
    month: "Måned",
    week: "Uke",
    day: "Dag",
    list: "Agenda"
  },
  weekLabel: "Uke",
  allDayText: "Hele dagen",
  eventLimitText: "til",
  noEventsMessage: "Ingen hendelser å vise"
};
